import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-block-list',
  templateUrl: './block-list.component.html',
  styleUrls: ['./block-list.component.scss'],
})
export class BlockListComponent {
  @Input() injectData = {};

  @Input() blockIdList: unknown[] = [];
}
